var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgQuotesStart = function SvgQuotesStart(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33.5 2.1c3.6 5.9 6.2 11.8 7.8 17.8 1.6 5.9 2.4 11.9 2.4 17.8 0 11.2-2.8 21.9-8.2 32.1C30 80 22.4 89.4 12.6 97.9L2.4 91.6c-1-.6-1.6-1.3-1.9-2-.3-.8-.5-1.5-.5-2.3 0-1.7.6-3.2 1.9-4.4 2-2.4 3.9-4.9 5.7-7.7 1.9-2.8 3.5-5.7 5-8.7s2.7-6.2 3.5-9.5c.9-3.3 1.3-6.9 1.3-10.6 0-3.9-.6-8-1.8-12.2s-3.2-8.6-6-13.3c-.9-1.4-1.3-2.7-1.3-4.1 0-3 1.7-5.1 5-6.5zm56.3 0c3.6 6 6.2 11.9 7.8 17.8s2.4 11.9 2.4 17.8c0 11.2-2.7 21.9-8.2 32.1s-13.1 19.5-22.9 28l-10.2-6.3c-1-.6-1.6-1.3-1.9-2-.3-.8-.5-1.5-.5-2.2 0-1.7.6-3.2 1.9-4.4 2-2.4 3.9-4.9 5.7-7.7 1.9-2.8 3.5-5.7 5-8.7s2.7-6.2 3.5-9.5c.9-3.3 1.3-6.9 1.3-10.6 0-3.9-.6-8-1.8-12.2s-3.2-8.6-6-13.3c-.9-1.4-1.3-2.7-1.3-4.1 0-3 1.7-5.1 5-6.5z"
  })));
};
export default SvgQuotesStart;